import { createFileRoute } from '@tanstack/react-router';
import NotFoundPage from '../pages/ErrorPage';

export const Route = createFileRoute('/404')({
  component: () => <NotFoundPage />,
});
